import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import NavHeader from './NavHeader';
import { GoogleLogin } from "@react-oauth/google";
import styles from './signup.module.css';
import IndianFlag from '../images/flag-india.png';
import GrowingArrow from '../images/growing-arrow.png';
import Exchange from '../images/exchange.png';
import Secure from '../images/secure.png';
import Footer from '../shared/Footer';

const Signup = () => {
    const [formData, setFormData] = useState({ emailOrPhone: '', password: '', name: '' });
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('Sending verification email...');
        try {
            const response = await axios.post('/api/authApplicant/signup', formData);
            setError(response.data.message);
            sessionStorage.setItem('verifyEmailOrPhone', formData.emailOrPhone);
            navigate('/verify');
        } catch (error) {
            const msg = error.response?.data?.message || 'An error occurred. Please try again.';
            setNotification(msg);
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <NavHeader />
        {notification && <Notification message={notification} onClose={() => setNotification('')} />}

        <div className={styles.signupPage}>
            <div className={styles.card}>

                {/* Header */}
                <div className={styles.cardHeader}>
                    <div className={styles.badge}>
                        <span className={styles.badgeDot}></span>
                        The ultimate Learn — Teach  App!
                    </div>
                    <h1 className={styles.headline}>
                        <span className={styles.exchangeText}> Exchange</span>
                        <span className={styles.skillsText}> Skills</span>
                        <span className={styles.comma}>, </span>
                            Chapters
                        <span className={styles.comma}>, </span>

                        <span className={styles.topicsText}> Topics</span> With 

                        <span className={styles.topicsText}> Friends</span>
                        <span className={styles.fullStop}>.</span>
                    </h1>
                    
                    {/* <div className={styles.trustRow}>
                        <div className={styles.trustItem}>📈 Growing users</div>
                        <div className={styles.trustItem}>⚡ 10 seconds</div>
                        <div className={styles.trustItem}>🔒 Secure</div>
                    </div> */}
                    <div className={styles.trustRow}>
                        {/* <div className={styles.trustItem}><img  title="India" src={GrowingArrow.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.GrowingArrow}/> Growing Users</div> */}
                        {/* <div className={styles.trustItem}>⚡ Join in 30 seconds</div> */}
                            {/* <div className={styles.trustItem}><img src={Exchange.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/> Exchange Skills-Chapters-Topics</div> */}
                        <div className={styles.trustItem}><img  title="India" src={IndianFlag.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/>Made in India</div>
                        {/* <div className={styles.trustItem}><img src={Secure.replace('/upload/', '/upload/w_96,h_100,c_fill/')} className={styles.IndianFlag}/> 100% Safe & Secure</div> */}
                        <div className={styles.trustItem}>🔒 100% Safe & Secure</div>
                    </div>
                </div>

                {/* <div className={styles.cardHeader}>
                    <div className={styles.badge}>
                        <span className={styles.badgeDot}></span>
                        The ultimate Learn — Teach  App!
                    </div>
                    <h1 className={styles.headline}>
                        <span className={styles.friendsText}> Learn</span> what you  
                        <span className={styles.wantText}> Want</span>
                        <span className={styles.comma}>,</span>
                        <br />
                        <span className={styles.wantText}> Teach</span> what you 
                        <span className={styles.friendsText}> Want</span>
                        <span className={styles.fullStop}>.</span>
                    </h1>
                     <p className={styles.subtext}><img  title="India" src={Exchange.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/> Exchange Topics-Skills-Chapters</p>

                    <div className={styles.trustRow}>
                        <div className={styles.trustItem}><img  title="India" src={GrowingArrow.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.GrowingArrow}/> Growing Users</div>
                        <div className={styles.trustItem}>⚡ Join in 30 seconds</div>
                         <div className={styles.trustItem}><img src={Exchange.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/> Exchange Skills-Chapters-Topics</div>
                        <div className={styles.trustItem}><img  title="India" src={IndianFlag.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/> Made in India</div>
                        <div className={styles.trustItem}><img src={Secure.replace('/upload/', '/upload/w_96,h_100,c_fill/')} className={styles.IndianFlag}/> 100% Safe & Secure</div>
                    </div>
                </div> */}

                <div className={styles.cardBody}>

                    {/* Google — primary CTA */}
                    <div className={styles.googleWrapper}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    const res = await axios.post("/api/authApplicant/google", { credential: credentialResponse.credential });
                                    localStorage.setItem("token", res.data.token);
                                    navigate("/");
                                } catch (err) {
                                    const msg = err.response?.data?.message || "Google Login Failed";
                                    setError(msg); setNotification(msg);
                                }
                            }}
                            onError={() => { setError("Google Login Failed"); setNotification("Google Login Failed"); }}
                            size="large"
                            text="signup_with"
                            theme="outline"
                            shape="rectangular"
                            // width="20"
                        />
                    </div>

                    <div className={styles.divider}>
                        <div className={styles.dividerLine}></div>
                        <span className={styles.dividerText}>or sign up with email</span>
                        <div className={styles.dividerLine}></div>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className={styles.signupForm}>
                        <div className={styles.fieldGroup}>

                            <div className={styles.fieldWrap}>
                                <span className={styles.fieldIcon}>👤</span>
                                <input
                                    className={styles.input}
                                    type="text"
                                    name="name"
                                    placeholder="Full name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className={styles.fieldWrap}>
                                <span className={styles.fieldIcon}>✉</span>
                                <input  
                                    className={styles.input}
                                    type="text"
                                    name="emailOrPhone"
                                    placeholder="Email"
                                    value={formData.emailOrPhone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            {/* <p className={styles.hintText}>📞 Phone: include country code e.g. +91</p> */}

                            <div className={styles.fieldWrap}>
                                <span className={styles.fieldIcon}>🔒</span>
                                <input
                                    className={styles.input}
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Create a password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                {/* <button
                                    type="button"
                                    className={styles.eyeBtn}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? '👁️' : '👁️'}
                                </button> */}
                            </div>

                        </div>

                        {error && <div className={styles.errorMsg}>{error}</div>}

                        <button type="submit" className={styles.submitBtn} disabled={loading}>
                            {loading ? 'Creating account…' : 'Create free account →'}
                        </button>
                        <p className={styles.freeLabel}>
                            {/* ✓ <span>Easy access</span> */}
                             {/* &nbsp;·&nbsp; No spam &nbsp;·&nbsp; */}
                             <b>&nbsp;·&nbsp; We value your privacy and security. </b>
                        </p>
                    </form>

                </div>

                <div className={styles.cardFooter}>
                    Already have an account? <a href="/login">Log in</a>
                </div>

            </div>
        </div>
        <Footer />
        </>
    );
};

export default Signup;